import NavBar from './NavBar';
import TopBar from './TopBar';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Link from '@material-ui/core/Link';
import MantenimientoBanner from 'src/components/MantenimientoBanner';

// ----------------------------------------------------------------------

const BANNER_DISMISSED_KEY = 'mfa_banner_dismissed';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
  },
  main: {
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE + 12,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
      paddingTop: APP_BAR_DESKTOP + 12,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  mfaBanner: {
    marginBottom: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

function DashboardLayout({ children }) {
  const classes = useStyles();
  const [openNav, setOpenNav] = useState(false);
  const [bannerDismissed, setBannerDismissed] = useState(
    () => localStorage.getItem(BANNER_DISMISSED_KEY) === 'true'
  );

  const { mfaActivo, mfaObligatorio, mfaConfigurado } = useSelector(
    state => state.authJwt
  );

  const showMfaBanner =
    mfaActivo && !mfaObligatorio && !mfaConfigurado && !bannerDismissed;

  const handleDismissBanner = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
    setBannerDismissed(true);
  };

  return (
    <div className={classes.root}>
      <TopBar onOpenNav={() => setOpenNav(true)} />
      <NavBar onCloseNav={() => setOpenNav(false)} isOpenNav={openNav} />

      <div className={classes.main}>
        {showMfaBanner && (
          <Alert
            severity="warning"
            className={classes.mfaBanner}
            onClose={handleDismissBanner}
          >
            <AlertTitle>Protege tu cuenta</AlertTitle>
            Activa la autenticación de dos factores (MFA) para mayor seguridad.{' '}
            <Link
              component={RouterLink}
              to="/app/management/user/account?tab=mfa"
              color="inherit"
              underline="always"
            >
              Configurar ahora
            </Link>
          </Alert>
        )}
        <MantenimientoBanner />
        {children}
      </div>
    </div>
  );
}

export default DashboardLayout;
